import { Place, PlacesApiResponse } from '../types/types';
import type { LatLngExpression } from "leaflet";
import { latLng } from 'leaflet';


// Handle empty object, missing places property, or empty places array
function extractPlacesFromApiResponse(data: PlacesApiResponse): Place[] {
  if (!data || Object.keys(data).length === 0 || !data.places || !Array.isArray(data.places)) {
    console.log('Returning empty object')
    return [];
  }
  return data.places;
}

export const getPlacesByLocation = async ( p : LatLngExpression , radius: number = 5000 ): Promise<Place[]> => {
 const { lat, lng } = latLng(p);
  try {
    const response = await fetch(
      `https://7gfyuakvzdypdtw7hhyntba4ha0tagdz.lambda-url.eu-west-1.on.aws/?latitude=${lat}&longitude=${lng}&radius=${radius}`
    );
    if (response.ok) {
      const data: PlacesApiResponse = await response.json();
      const places = extractPlacesFromApiResponse(data);
    return places;
    }
    return []
  } catch (error) {
    console.error('Error calling Lambda API:', error);
    return [] ;
  }
};
